import {
  deleteItem,
  getItems,
  storeItem,
  updateItem
} from "../api-helpers/api-items";

export default {
  state: {
    isGettingItems: false,
    items: null,
    isStoringItem: false,
    isUpdatingItem: false,
    isDeletingItem: false
  },
  mutations: {
    setIsGettingItems(state, bool) {
      state.isGettingItems = bool;
    },
    setItems(state, items) {
      state.items = items;
    },
    setIsStoringItem(state, bool) {
      state.isStoringItem = bool;
    },
    setIsUpdatingItem(state, bool) {
      state.isUpdatingItem = bool;
    },
    setIsDeletingItem(state, bool) {
      state.isDeletingItem = bool;
    }
  },
  actions: {
    async getItems({ commit, state }) {
      let items = null;
      if (!state.isGettingItems) {
        commit("setIsGettingItems", true);

        items = await getItems();
        commit("setItems", items);

        commit("setIsGettingItems", false);
      }

      return items;
    },
    async storeItem({ commit, state, rootState, dispatch }, item) {
      let response;
      if (!state.isStoringItem) {
        commit("setIsStoringItem", true);

        response = await storeItem(item);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Item created successfully.",
          errorText: "An error occurred while attempting to create Item.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchItems", rootState.Search.searchTerm);
            } else {
              dispatch("getItems");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringItem", false);
      }
      return response;
    },
    async updateItem({ commit, state, rootState, dispatch }, item) {
      let response;
      if (!state.isUpdatingItem) {
        commit("setIsUpdatingItem", true);

        response = await updateItem(item);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Item updated successfully.",
          errorText: "An error occurred while attempting to update Item.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchItems", rootState.Search.searchTerm);
            } else {
              dispatch("getItems");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingItem", false);
      }
      return response;
    },
    async deleteItem({ commit, state, rootState, dispatch }, item) {
      let response;
      if (!state.isDeletingItem) {
        commit("setIsDeletingItem", true);

        response = await deleteItem(item);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Item deleted successfully.",
          errorText: "An error occurred while attempting to delete Item.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchItems", rootState.Search.searchTerm);
            } else {
              dispatch("getItems");
            }
            commit("resetConfirmationModalParams");
          }
        });

        commit("setIsDeletingItem", false);
      }
      return response;
    }
  }
};
